
function DesktopOnlySite() {
    return (
        <div className="desktop-only-site">
            <h2>Sorry 😧! This is only available on desktops for now..</h2>
        </div>
    );
}

export default DesktopOnlySite;